var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.99992 5.49992C6.39045 5.1094 7.02361 5.1094 7.41414 5.49992L12.4999 10.5857L17.5857 5.49997C17.9762 5.10945 18.6094 5.10945 18.9999 5.49997C19.3905 5.8905 19.3905 6.52366 18.9999 6.91419L13.9141 11.9999L18.9999 17.0858C19.3904 17.4763 19.3904 18.1095 18.9999 18.5C18.6094 18.8905 17.9762 18.8905 17.5857 18.5L12.4999 13.4142L7.41414 18.5C7.02362 18.8905 6.39045 18.8905 5.99993 18.5C5.6094 18.1094 5.6094 17.4763 5.99993 17.0858L11.0857 11.9999L5.99992 6.91414C5.6094 6.52361 5.6094 5.89045 5.99992 5.49992Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.1b0b126ba4e7df84304db2ea5777c199.svg";
export { ForwardRef as ReactComponent };